export default function RequestList({ setRequestReply, setReplyData, stopRequestList, setRequest }: any) {
  const detailHandler = (stopRequest: any) => {
    setReplyData(stopRequest);
    setRequestReply(true);
  };

  return (
    <div className='bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center overflow-auto scrollbar-hide h-[calc(100%-157px)] md:h-[calc(100%-392px)]'>
      <div className='flex justify-end w-[235px] sm:w-[308px] md:w-[750px] pt-12 md:pt-[30px]'>
        <button onClick={() => { setRequest(true); }}
          className='w-85 h-32 md:w-[212px] md:h-[80px] text-14 md:text-35 text-white leading-16 md:leading-[40px] rounded-[5px] md:rounded-[12px] bg-gradient-to-r from-gdFrom to-gdTo mr-9 md:mr-[22px]'>작업중지요청</button>
      </div>
      <div className='w-[235px] sm:w-[308px] md:w-[750px] pt-10 mb-20 md:pt-[25px] md:mb-[50px]'>
        {stopRequestList ? stopRequestList.length > 0 ? stopRequestList.map((stopRequest: any, idx: number) => {
          return (
            <div key={idx} onClick={() => detailHandler(stopRequest)}>
              <div className='border border-x-0 border-t-0 border-[#CACACA] w-full mt-10 md:mt-[25px]' />
              <div className='flex mt-22 md:mt-[55px] justify-between items-center'>
                <p className='text-15 leading-18 md:text-37 md:leading-[45px] font-preBold truncate'>{stopRequest.evntNm}</p>
                {stopRequest.prcsStatCd === '001' ? <div className='w-63 h-26 md:w-[157px] md:h-[65px] bg-[#585959] rounded-[4px] text-13 leading-15 md:rounded-[10px] md:text-32 md:leading-[37px] text-white flex items-center justify-center font-preLight'>중지요청</div>
                  : stopRequest.prcsStatCd === '002' ? <div className='w-63 h-26 md:w-[157px] md:h-[65px] bg-point text-13 leading-15 rounded-[4px] md:rounded-[10px] md:text-32 md:leading-[37px] text-white flex items-center justify-center font-preLight'>작업중지</div>
                    : <div className='w-63 h-26 md:w-[157px] md:h-[65px] bg-[#F2F4F6] rounded-[4px] text-13 leading-15 md:rounded-[10px] md:text-32 md:leading-[37px] text-[#9C9C9B] flex items-center justify-center font-preLight'>작업재개</div>
                }
              </div>
              <p className={`text-14 leading-17 mt-7 md:text-35 md:leading-[42px] md:mt-[17px]`}><span>{stopRequest.exbtPlc}</span></p>
              <p className='text-14 leading-17 text-[#706F6F] mt-8 md:leading-[42px] md:mt-[20px]'>{stopRequest.rgstCmpnyNm}</p>
              <p className='text-14 leading-17 text-[#706F6F] mt-8 md:leading-[42px] md:mt-[20px]'>{stopRequest.rgstTime}</p>
            </div>)
        }) : <p className={`text-15 leading-18 md:text-37 md:leading-[45px] font-preBold truncate`}>조회된 데이터가 없습니다.</p> : null}
      </div>
    </div>

  );
}